import { useEffect } from 'react'

import { WizardStepContainer } from '../layout/WizardStepContainer'
import { navigationState } from '../utilities/navigation'
import { WizardPageContent } from './WizardPageContent'
import { WizardStepProps } from './WizardTypes'

export const WizardStep = ({ showExitConfirmation = false, ...props }: WizardStepProps) => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (showExitConfirmation && !navigationState.isExternalNavigation) {
        event.preventDefault()
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [showExitConfirmation])

  return (
    <WizardStepContainer {...props}>
      <WizardPageContent {...props} />
    </WizardStepContainer>
  )
}
